<template>
    <div>
        <div class="info-title">机票预定</div>

        <div class="form-info-panel" style="padding: 0.4rem; text-align: left">
          <div
            v-for="(item, index) in course_data"
            style="padding-bottom: 24px"
            @click="editPerson(item, index)"
          >
            <div style="position: relative">
              <div style="font-size: 14px; font-weight: bold">
                {{ item.name ? item.name : "??" }}
              </div>
              <div style="font-size: 12px; margin-top: 6px">
                {{ cardtypeTxt(item.cardtype) }}：{{ item.idcard }}
              </div>

              <div
                style="
                  position: absolute;
                  right: 0;
                  font-size: 22px !important;
                  top: 50%;
                  transform: translateY(-50%);
                  color: #1889f9 !important;
                "
              >
                <van-icon
                  name="edit"
                  style="
                    display: inline-block;
                    vertical-align: middle;
                    font-size: 22px !important;
                    color: #1889f9 !important;
                  "
                />
              </div>
            </div>
          </div>

          <a
            style="
              display: inline-block;
              width: 100%;
              border-radius: 0.125rem;
              line-height: 0.7rem;
              font-family: PingFangSC-Regular;
              font-size: 0.3rem;
              color: #1889f9;
              border: 1px solid #9f9f9f;
              text-align: center;
            "
            href="javascript:void(0);"
            v-on:click="addCourse"
            v-bind:class="{ inEdit: !nextStepValid }"
          >
            <van-icon
              name="add-o"
              style="
                display: inline-block;
                margin-right: 6px;
                vertical-align: middle;
              "
            />
            <span style="display: inline-block; vertical-align: middle"
              >添加游客</span
            >
          </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CheeseFooter',
        props: ['footerType','addUrl'],
        created:function()
        {
            console.log(this.footerType);
        },
        methods:{
            add()
            {
                this.$router.push(this.addUrl);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .cheese_footer
    {
        font-family: PingFangSC-Regular;
        font-size: 0.3125rem;
        color: #B2B2B2;
        text-align: center;
        line-height: 0.4375rem;
    }

    .fix_footer{
        position: absolute;
        left:50%;
        bottom: 2.5rem;
        text-align: center;
        z-index: 99;

    }

    .bottom_footer{
        margin-bottom: .5rem;
        margin-top: .5rem;
    }

    .new-btn
    {
        line-height: 1rem;
        padding: 0 1rem;
        border-radius: 1rem;
        background-color: #1989FA;
        color: #ffffff;
        font-size: .4rem;
        transform: translateX(-50%);
    }
</style>
